import React, { useState } from "react"
import NumberInput from "../../common/components/NumberInput"
import customersActions from "../customersActions"

export const CustomerCodeSelector = (props: { label?: string, idCliente: number | null, code: number, onChange: (code: number) => void }) => {
    const [state, setState] = useState<{ code: number, error?: string | undefined }>({ code: props.code });


    const onBlur = async (code: number) => {
        const exist = await customersActions.codiceClienteAziendaExist(code, props.idCliente);
        if (exist) {
            setState({
                code,
                error: "Il codice inserito esiste già"
            })
        }
        else {
            setState({ code, error: "" })
        }

        props.onChange(code);

    }


    return <NumberInput
        className="form-control"
        label={props.label}
        value={state.code}
        onChange={onBlur}
        error={state.error}
    />
}